import { render, staticRenderFns } from "./TeacherSubjectClassAddEdit.vue?vue&type=template&id=334f5560"
import script from "./TeacherSubjectClassAddEdit.vue?vue&type=script&lang=js"
export * from "./TeacherSubjectClassAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports